import Translate from "utils/Translate";
import React, { useContext } from 'react'
import './css/ButtonStyles.css'
import Tag from 'components/icons/Tag';
import Close from 'components/icons/Close';
import { AppContext } from 'contexts/AppContext';
import { useMediaQuery } from "@mui/material";

const LabelTag1 = (props) => {
    const { styleGuide } = useContext(AppContext)
    const isMobile = useMediaQuery('(max-width:768px)');
    const showIcon = (typeof props.showIcon === 'boolean') ? props.showIcon : true
    const showClose = (typeof props.showClose === 'boolean') ? props.showClose : true
    const LabelTag1Style = {
        fontFamily: styleGuide.secondaryFontFamily,
        color: props.color ? props.color : styleGuide.color1,
        backgroundColor: props.backgroundColor ? props.backgroundColor : styleGuide.color12,
        border: props.border ? props.border : `1px solid ${styleGuide.color12}`,
        fontWeight: '600',
        border: 'none',
        fontSize: styleGuide.labelTagFontSize,
        padding: isMobile ? '3px 8px' : '5px 14px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: 'max-content',
        textdecoration: 'none',
        fontSize: isMobile ? 11 : styleGuide.labelTagFontSize
    }

    return (
        <span
            style={{...LabelTag1Style, ...props.style}}
            className={props.className}
            onClick={props.onClick}
        >   
            {showIcon && !isMobile
                ?   props.icon 
                        ? props.icon
                        : <Tag style={{ marginRight:'10px', height: 10, width: 10 }}  fill={styleGuide.color1} />
                :   null
            }
            <Translate translationKey={props.translationKey}>{props.fallbackText || props.children}</Translate>
            {showClose 
                ?   <Close style={{ marginLeft: '12px', height: 10, width: 10 }}  fill={styleGuide.color1} />
                :   null
            }
        </span>
    )
}

export default LabelTag1;